<div class="flip-container" data-repeat="true" data-transform="preset(d, h, m, s) -> delay">
    <div class="tick-group">
        <div class="digits" data-key="value" data-repeat="true" data-transform="pad(00) -> split -> delay">
            <span data-view="flip"></span>
        </div>
        <span data-key="label" data-view="text" class="tick-label"></span>
    </div>
</div>
